import { Component, inject, OnInit, signal } from '@angular/core';
import { NzContentComponent, NzLayoutComponent, NzSiderComponent } from 'ng-zorro-antd/layout';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HeaderComponent } from './components/header/header.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { filter } from 'rxjs';
import { CommonService } from '../shared/services/common.service';
import { SharedDataService } from '../shared/services/shared-data.service';
import { mapPaymentChannelsFromApi } from '../shared/models/common.models';
import { take } from 'rxjs';

@Component({
  selector: 'race-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
  imports: [
    NzContentComponent,
    RouterOutlet,
    NzSiderComponent,
    NzLayoutComponent,
    SidebarComponent,
    HeaderComponent,
    NzDrawerModule,
  ],
})
export class MainLayoutComponent implements OnInit {
  isCollapsed = false;
  readonly isMobile = signal(false);
  drawerVisible = false;

  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly router = inject(Router);
  private readonly commonService = inject(CommonService);
  private readonly sharedDataService = inject(SharedDataService);

  ngOnInit(): void {
    if (!this.sharedDataService.paymentChannelsLoaded() && !this.sharedDataService.paymentChannelsLoading()) {
      this.sharedDataService.setPaymentChannelsLoading(true);
      this.commonService
        .getPaymentChannel({ status: 'ACTIVE' })
        .pipe(take(1))
        .subscribe({
          next: (res: { data?: { code: string; paymentChannelName: string }[] }) => {
            this.sharedDataService.setActivePaymentChannels(mapPaymentChannelsFromApi(res?.data ?? []));
          },
          error: (err) => {
            console.error(err);
            this.sharedDataService.setPaymentChannelsLoading(false);
          },
        });
    }
  }

  constructor() {
    this.breakpointObserver.observe(['(max-width: 767px)']).subscribe((result) => {
      this.isMobile.set(result.matches);
      if (!this.isMobile()) {
        this.drawerVisible = false;
      }
    });

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      if (this.drawerVisible) {
        this.drawerVisible = false;
      }
    });
  }

  toggleSidebar(): void {
    if (this.isMobile()) {
      this.drawerVisible = true;
    } else {
      this.isCollapsed = !this.isCollapsed;
    }
  }

  closeDrawer(): void {
    this.drawerVisible = false;
  }

  collapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  onActivate(event: any): void {
    window.scroll(0, 0);
  }
}
